<template>
  <div v-if="!malformed" class="report">
    <button class="btn isDefault isPrint" @click="print()">
      <icon type="printer" size="16"/>Vytisknout
    </button>

    <h4 class="centered">
      <img src="../assets/gymbk-logo.png" class="logo">
      Gymnázium Blansko, příspěvková organizace
    </h4>
    <h2 class="centered">{{ this.heading }}</h2>

    <p>Jméno a příjmení žáka: {{ metadata.thesisAuthor }}</p>
    <p>Třída: {{ metadata.className }}</p>
    <p>Školní rok: {{ schoolYear }}</p>
    <p>Předmět: {{ metadata.field }}</p>
    <p>Téma práce: {{ metadata.title }}</p>
    <p v-if="this.author === 'supervisor'">Vedoucí práce: {{ metadata.author }}</p>
    <p v-if="this.author === 'reader'">Oponent práce: {{ metadata.author }}</p>

    <hr>
    <h4>Hodnocení práce</h4>

    <h4 class="offset">1. Hodnocení maturitní práce v základních oblastech:</h4>
    <table class="centered">
      <tr>
        <th>Oblast hodnocení</th>
        <th>Body</th>
      </tr>
      <tr v-for="(row, index) in assessmentRows" :key="index" v-if="row.value || row.value === 0">
        <td>{{ row.title }}</td>
        <td>{{ row.value }}</td>
      </tr>
    </table>

    <h4 class="offset">2. Zdůvodnění hodnocení:</h4>
    <p>{{ reportData.text }}</p>

    <h4 class="offset">3. Otázky k obhajobě:</h4>
    <ul>
      <li class="offset-left" v-for="(question, index) in reportData.questions" :key="index">
        <p>{{ question }}</p>
      </li>
    </ul>

    <h4 class="offset">4. Obhajoba maturitní práce:</h4>
    <table class="centered">
      <tr>
        <th>Oblast hodnocení</th>
        <th>Body</th>
      </tr>
      <tr>
        <td>Obhajoba maturitní práce</td>
        <td></td>
      </tr>
      <tr>
        <td>Prezentace</td>
        <td></td>
      </tr>
    </table>

    <h4 class="offset">
      5. Celkový počet bodů:
      <span>____________</span>
    </h4>

    <h4 class="offset">
      6. Navržený klasifikační stupeň:
      <span>____________</span>
    </h4>

    <p class="footie">
      V Blansku
      <span>_______________</span>
    </p>
    <p class="righthand">podpis</p>
  </div>
</template>

<script>
import { getSchoolYear } from '../util';

export default {
  data() {
    return {
      malformed: false,
      author: null,
      reportData: null,
      metadata: null,
      assessmentCategories: [
        'Kvalita pojednání tématu práce',
        'Věcná správnost',
        'Vlastní přínos žáka',
        'Dosažení cíle práce',
        'Práce se zdroji',
        'Formální zpracování, grafická úprava, jazyková a stylistická správnost',
        'Spolupráce s vedoucím práce'
      ]
    };
  },

  computed: {
    heading() {
      return `Posudek ${
        this.author === 'supervisor' ? 'vedoucího' : this.author === 'reader' ? 'oponenta' : ''
      } maturitní práce`;
    },

    assessmentRows() {
      try {
        return this.reportData.points.map((value, index) => {
          return {
            title: this.assessmentCategories[index],
            value
          };
        });
      } catch (e) {
        return null;
      }
    },

    schoolYear() {
      return getSchoolYear();
    }
  },

  methods: {
    print() {
      window.print();
    }
  },

  async created() {
    const { author } = this.$route.query;
    this.author = author;

    if (!['supervisor', 'reader'].includes(author)) {
      this.malformed = true;
    } else {
      this.reportData = this.$store.getters.report(author);
      this.metadata = this.$store.getters.metadata;
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/buttons.sass';

.report
  padding: 3rem 1rem
  font-family: 'Arial', sans-serif
  color: black
  line-height: 20px

.centered
  text-align: center

.offset
  margin: 2rem 0 2rem 2rem

.offset-left
  margin-left: 2rem

.footie
  margin-top: 3.25rem

.righthand
  margin-right: 2rem
  width: 135px
  float: right
  text-align: center

.logo
  width: 120px

h2
  margin: 3rem 0 2.5rem !important
  text-decoration: underline

h4
  color: black !important

  & img
    margin-right: 1rem

h4 span, p span
  float: right
  margin-right: 2rem

hr
  border-bottom: 1px solid black

table
  width: 90%
  margin: 0 auto 3.5rem !important

th
  color: black !important

th, td
  border: 1px solid black !important
  padding: .25rem .75rem

table > tr > *:first-child
  width: 85%

table td:last-child
  text-align: center

ul
  list-style-type: square

</style>
